import {
    STORE_ORDERS,
    STORE_ORDER_RESPONSE, STORE_MARKETPLACE_COMPANIES, STORE_MARKETPLACE_NAMES_BY_COMPANY,
    STORE_WALMART_ORDERS, CLEAR_WALMART_ORDERS
} from "../../constants/admin";

const initialState = {
    orders: [],
    orderResponse: {},
    marketplaceCompanies: [],
    marketplaceCountries: [],
    walmartOrders: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case STORE_ORDERS:
            return {
                ...state,
                orders: action.orders
            }
        case STORE_ORDER_RESPONSE:
            return {
               ...state,
               orderResponse: action.data.types
            }
        case STORE_MARKETPLACE_NAMES_BY_COMPANY:
            return {
                ...state,
                marketplaceNamesByCompany: action.data.marketplaceNames
            }
        case STORE_MARKETPLACE_COMPANIES:
            return {
                ...state,
                marketplaceCompanies: action.data
            }
        case STORE_WALMART_ORDERS:
            return {
                ...state,
                walmartOrders: action.orders
            }
        case CLEAR_WALMART_ORDERS:
            return {
                ...state,
                walmartOrders: []
            }
        default:
            return state
    }
};